// extracted by mini-css-extract-plugin
export default {"container":"InputArea_container__ATy56","input":"InputArea_input__wGsQ-","sendButton":"InputArea_sendButton__tDtKE"};